(function () {
  function fixZienyButtonLayout() {
    document.querySelectorAll('.zieny-ai-btn').forEach(function (button) {
      if (button.style.display === 'block' || button.style.display === 'inline-block') {
        button.style.display = 'flex';
      }
    });
  }

  function bindButtonGuards() {
    document.querySelectorAll('.zieny-ai-btn').forEach(function (button) {
      if (button.dataset.zienyGuardBound === 'true') return;
      button.dataset.zienyGuardBound = 'true';

      button.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      new MutationObserver(fixZienyButtonLayout).observe(button, {
        attributes: true,
        attributeFilter: ['style'],
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    fixZienyButtonLayout();
    bindButtonGuards();
  });
})();
